// extracted by mini-css-extract-plugin
export default {"modalHeader":"ConfirmModal_modalHeader__R+p8N","contrast":"ConfirmModal_contrast__Zp2B+","modalBody":"ConfirmModal_modalBody__+kVnC"};